// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__1bO+E","topBar":"MainLayout_topBar__qTBmY","bottom":"MainLayout_bottom__MipUy","sideNav":"MainLayout_sideNav__yFr86","main":"MainLayout_main__6tX1R"};